import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import EventsList from '../../components/events/EventsList';
import EventForm from '../../components/events/EventForm';
import EventDetails from '../../components/events/EventDetails';

const EventDetailsWrapper = () => {
  const { id } = useParams();
  return <EventDetails eventId={id} />;
};

const EventFormWrapper = () => {
  const { id } = useParams();
  return <EventForm eventId={id} />;
};

const EventsManagement = () => {
  return (
    <div className="space-y-6">
      <Routes>
        <Route index element={<EventsList />} />
        <Route path="new" element={<EventForm />} />
        <Route path=":id" element={<EventDetailsWrapper />} />
        <Route path=":id/edit" element={<EventFormWrapper />} />
      </Routes>
    </div>
  );
};

export default EventsManagement;